import http from '@/v2/utils/http'
import { baseData, examData, networkData, configData } from '@/v2/utils/data'

export const cardApi = {
  templateList: params => http.post('/marking-exam-manager/answer-sheet/search', params), // 查询模板列表
  changeTemplate: params => http.put('/marking-exam-manager/answer-sheet/update-template-attribute', params), // 修改模板基本信息
  reuseTemplate: params => http.post('/marking-exam-manager/answer-sheet/reuse', params), // 复制模板
  deleteTemplate: params => http.delete(`/marking-exam-manager/answer-sheet/delete-by-id?id=${params.id}&version=${params.version}`), // 删除模板
  templateStatus: params => http.put(`/marking-exam-manager/answer-sheet/update-open-status?id=${params.id}&status=${params.status}&version=${params.version}`), // 切换是否公开
  changeGade: (templateId, gradeId) => http.put(`/marking-exam-manager/sheet-template/${templateId}/grade_id/${gradeId}`),
  thirdCardList: params => http.post('/marking-exam-manager/sheet-template-img/list', params), // 第三方制卡
  uploadCardImg: params => http.put('/marking-exam-manager/sheet-template-img/save-or-update', params), // 更新第三方制卡
  deleteCardImg: id => http.delete('/marking-exam-manager/sheet-template-img/' + id, {}), // 删除第三方制卡
  downloadZujuanPaper: params => http.post(`/marking-exam-manager/answer-sheet/${params.id}/download-zu-juan-zip?version=${params.version}`, {}),
  saveTemplate: params => http.post('/marking-exam-manager/answer-sheet/save-third-sheet-template', params),
  getTemplate: id => http.get(`/marking-exam-manager/answer-sheet/get-third-sheet-template/${id}`),
  getTemplateOld: id => http.get('/marking-exam-manager/sheet-template/' + id),
  addTemplateOld: params => http.post('/marking-exam-manager/sheet-template', params),
  updateTemplate: params => {
    if (!params.id) {
      const message = '制卡模板id为空，更新失败'
      window.SlsSend({
        action: 'updateTemplate',
        desc: message
      })
      return Promise.resolve({
        success: false,
        message
      })
    }
    return http.put('/marking-exam-manager/sheet-template/' + params.id, params)
  },
  // 组卷制卡相关接口
  initZujuanCard: paperId => http.get(`/marking-exam-manager/answer-sheet/init-zu-juan-sheet/${paperId}`), // 初始化组卷制卡
  downloadOriginZujuan: paperSnapshotId => http.get(`/marking-exam-manager/answer-sheet/zu-juan-document/${paperSnapshotId}`), // 获取组卷制卡的原卷地址
  // 切题识别相关接口 - START
  checkSkew: params => http.post('/marking-exam-manager/recognition/paper-skew', params), // 检测倾斜度
  checkDogear: params => http.post('/marking-exam-manager/recognition/paper-dogear', params), // 检测折角
  setObjective: params => http.post('/marking-exam-manager/stand/position/objective', params), // 客观题定位
  setExamNumber: params => http.post('/marking-exam-manager/stand/position/exam-number', params), // 定位填涂考号
  setClassExamNumber: params => http.post('/marking-exam-manager/stand/position/class-exam-number', params), // 定位班级学号
  setAbsentSmear: params => http.post('/marking-exam-manager/stand/position/absent-smear', params), // 定位缺考标记
  concatSheet: params => http.post('/marking-exam-manager/recognition/answer-sheet/concat', params), // 拼接答题卡
  // 切题识别相关接口 - END
  getMultiTemplateBoxs: params => http.get(`/marking-exam-manager/exam-sheet/exam/${params.examId}/sheet-by-template/v2`, params),
  createMultiTemplate: (examId, params) => http.post(`/marking-exam-manager/exam-sheet/exam/${examId}/sheet`, params),
  setBarcode: params => http.post('/marking-exam-manager/recognition/recognition/barcode/V2', params), // 条形码识别
  setHandWrittencode: params => http.post('/marking-exam-manager/recognition/hand_written_numeral/position', params), // 手写考号识别
  setScoreBox: params => http.post('/marking-exam-manager/recognition/recognition/score-box/v2', params), // 登分框识别
  setScoreBar: params => http.post('/marking-exam-manager/recognition/recognition/score-bar', params), // 打分条识别
  createThirdCard: params => http.post('/marking-exam-manager/answer-sheet/upsert-third-sheet-template', params), // 创建或更新第三方制卡（多张答题卡）
  updateThirdCardAfterBind: params => http.post('/marking-exam-manager/answer-sheet/save-grading-template', params), // 更新绑卡后第三方制卡（多张答题卡）
  updateDownloadTimes: params => http.put(`/marking-exam-manager/answer-sheet/inc-download-count/${params.version}/${params.id}`), // 更新答题卡下载次数
  getMainTemplate: examId => http.get(`/marking-exam-manager/answer-sheet/main-template-img/exam-id/${examId}`), // 获取主模版信息
  getAllTemplate: params => http.get('/marking-exam-manager/exam-stand-state/list-By-ExamId-And-Optional-TemplateNum', params), // 获取所有模版信息
  downloadCard: (params) => new Promise((resolve, reject) => {
    const url = `/marking-exam-manager/answer-sheet/download/${params.version}/${params.id}`
    http.downloadWithHeaders(url).then(resp => {
      // 确保 blob 类型正确
      resolve(resp)
    })
  })// 下载文件并更新下载次数
}

export const createCardApi = {
  createCardId: () => http.get('/marking-exam-manager/answer-sheet'), // 生成答题卡id
  createCard: params => http.post('/marking-exam-manager/answer-sheet/create', params), // 创建答题卡
  getCardById: id => http.get(`/marking-exam-manager/answer-sheet/get-by-id/${id}`), // 根据id获取答题卡
  updateCard: params => http.put('/marking-exam-manager/answer-sheet/update', params), // 编辑保存答题卡
  getZujuanQuestions: params => http.post('/marking-exam-manager/answer-sheet/fill-zu-juan-question-content', params), // 获取组卷制卡填充的试题（题干信息）
  getThirdCardAfterBind: (params) => http.get(`/marking-exam-manager/answer-sheet/exam-id/${params.examId}/template-num/${params.templateNum}`), // 获取绑卡后-第三方答题卡信息
  getThirdCardPreview: templateId => http.get(`/marking-exam-manager//answer-sheet/preview/template-id/${templateId}`).then(resp => {
    return networkData.getStandAnswerList(resp)
  }), // 获取第三方答题卡预览信息(绑卡前)
  checkFeatureOcr: params => http.post('/marking-exam-manager/recognition/check-feature', params) // 检查是否支持二维码识别
}
